const SvgDisableWarning = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25372_14314)">
        <path
          d="M12.5 2C6.98603 2 2.5 6.48604 2.5 12C2.5 17.514 6.98603 22 12.5 22C18.014 22 22.5 17.514 22.5 12C22.5 6.48604 18.014 2 12.5 2ZM12.5 3.5C17.2033 3.5 21 7.2967 21 12C21 16.7033 17.2033 20.5 12.5 20.5C7.79669 20.5 4 16.7033 4 12C4 7.2967 7.79669 3.5 12.5 3.5ZM12.5 7C12.2348 7 11.9804 7.10536 11.7929 7.29289C11.6054 7.48043 11.5 7.73478 11.5 8C11.5 8.26522 11.6054 8.51957 11.7929 8.70711C11.9804 8.89464 12.2348 9 12.5 9C12.7652 9 13.0196 8.89464 13.2071 8.70711C13.3946 8.51957 13.5 8.26522 13.5 8C13.5 7.73478 13.3946 7.48043 13.2071 7.29289C13.0196 7.10536 12.7652 7 12.5 7ZM12.4883 10.4893C12.2895 10.4924 12.1002 10.5742 11.9617 10.7169C11.8233 10.8595 11.7471 11.0513 11.75 11.25V16.75C11.7486 16.8494 11.767 16.9481 11.804 17.0403C11.8411 17.1325 11.8961 17.2164 11.9659 17.2872C12.0357 17.358 12.1188 17.4142 12.2105 17.4526C12.3022 17.4909 12.4006 17.5107 12.5 17.5107C12.5994 17.5107 12.6978 17.4909 12.7895 17.4526C12.8812 17.4142 12.9643 17.358 13.0341 17.2872C13.1039 17.2164 13.1589 17.1325 13.196 17.0403C13.233 16.9481 13.2514 16.8494 13.25 16.75V11.25C13.2514 11.1496 13.2327 11.05 13.1949 10.957C13.1571 10.8639 13.1011 10.7795 13.03 10.7085C12.959 10.6376 12.8745 10.5816 12.7814 10.544C12.6883 10.5063 12.5887 10.4877 12.4883 10.4893Z"
          className="fill-current"
        />
      </g>
      <defs>
        <clipPath id="clip0_25372_14314">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgDisableWarning;
